var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactsSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 158,
    viewBox: "0 0 159 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20605,
    y: 1.3916,
    width: 156,
    height: 155,
    rx: 73,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.226 62.8403H66.1043C65.0105 62.8403 64.124 63.7121 64.124 64.7876V93.9955C64.124 95.0709 65.0105 95.9427 66.1043 95.9427H107.226C108.321 95.9427 109.207 95.0711 109.207 93.9955V64.7874C109.207 63.712 108.32 62.8403 107.226 62.8403ZM101.824 66.7347L86.1405 79.7958L71.289 66.7347H101.824ZM105.246 92.0482H68.0844V69.1415L84.7847 83.8286C85.5206 84.4763 86.6308 84.4906 87.384 83.863L105.246 68.9884V92.0482H105.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4273 77.4443H56.9949C55.9012 77.4443 55.0146 78.3161 55.0146 79.3916C55.0146 80.467 55.9012 81.3388 56.9949 81.3388H60.4272C61.5209 81.3388 62.4074 80.467 62.4074 79.3916C62.4074 78.3161 61.521 77.4443 60.4273 77.4443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4272 85.3633H51.1863C50.0926 85.3633 49.2061 86.2349 49.2061 87.3104C49.2061 88.3859 50.0926 89.2576 51.1863 89.2576H60.4272C61.5209 89.2576 62.4075 88.3859 62.4075 87.3104C62.4073 86.2349 61.5209 85.3633 60.4272 85.3633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4272 69.5259H51.1863C50.0926 69.5259 49.2061 70.3976 49.2061 71.4731C49.2061 72.5486 50.0926 73.4203 51.1863 73.4203H60.4272C61.5209 73.4203 62.4075 72.5486 62.4075 71.4731C62.4075 70.3976 61.5209 69.5259 60.4272 69.5259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    fill: "white",
    transform: "translate(49.2061 49.8916)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsSvg);
export default __webpack_public_path__ + "static/media/contactsSvg.12c0928e1698057f12f3479efbff16f9.svg";
export { ForwardRef as ReactComponent };